'use strict';exports.__esModule = true;var _constants = require('../constants');
var _shortLinkHandler = require('../middleware/short-link-handler');

var stripProtocol = function stripProtocol(str) {
  var protocolEnd = str.indexOf('://');
  if (protocolEnd !== -1) {
    return str.substr(protocolEnd + 3);
  }
  return str;
};

var makeSharingUrl = function makeSharingUrl(route) {var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.language.default;var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.shareUrl;
  var parts = route.split('/').filter(function (p) {return p;});
  var short = parts.length && _shortLinkHandler.SHORT_LINK_REDIRECT_MAP[parts[0]];
  var locale = lang === _constants.language.default ? '' : lang || '';

  if (short) {
    parts[0] = short;
    locale = locale && _shortLinkHandler.LANGUAGE_KEYS_MAP[locale] || '';
    return stripProtocol(base + '/' + locale + parts.join('/'));
  }

  locale = locale && '/' + locale;
  return '' + base + locale + route;
};exports.default =

makeSharingUrl;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/makeSharingUrl.js
// module id = 61
// module chunks = 0